import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getDomainValueForCode, getTimeAgo } from '../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../library/Service/axiosClient';
import { application } from 'express';

const ViewAppliedsModal = ({handleOpenModal}:any) => {
    const { state, dispatch } = useContext(SmartContext);

    const showFlag = state?.modalFlags?.showJobViewApplieds;
    const jobData = state?.modalData?.data;
    const [filterType, setFilterType] = useState<'ALL' | 'STUDENT' | 'ALUMNI'>('ALL');
    const [statusFilter, setStatusFilter] = useState<string>('ALL');

    const [interestedList, setInterestedList] = useState<any[]>([]);
    useEffect(() => {
        if (!showFlag || !jobData?.id) return;

        const fetchInterestedUsers = async () => {
            try {
                const response = await axiosClient().post(
                    `${process.env.REACT_APP_JOB_SERVER}/jobs/intrested-applied-users`,
                    { jobId: jobData.id, type : 'APPLIED' }
                );

                console.log('response', response);

                if (response.data?.success) {
                    setInterestedList(response.data?.data);
                }
            } catch (error) {
                console.error(error);
                setInterestedList([]);
            }
        };

        fetchInterestedUsers();
    }, [showFlag, jobData?.id]);


    console.log("interestedList",interestedList)
    const studentCount = interestedList.filter(
        (u) => u.userTypeCode === 'STUDENT'
    ).length;

    const alumniCount = interestedList.filter(
        (u) => u.userTypeCode === 'ALUMNI'
    ).length;

    const filteredList = interestedList.filter((u) => {
        const userTypeMatch =
            filterType === 'ALL' || u.userTypeCode === filterType;

        const statusMatch =
            statusFilter === 'ALL' || u.applicationStatus === statusFilter;

        return userTypeMatch && statusMatch;
    });

    const applicationStatuses = state?.domain?.get('JOB_APPLICATION_STATUS');  

    return (
        <>
        <div
            className={`modal fade px-3 ${showFlag ? 'show' : ''}`}
            style={{ display: showFlag ? 'block' : 'none' }}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered max-900 mx-auto">
                <div className="modal-content radius-15">
                    <div className="modal-body p-4 p-md-5">
                        <h5 className="font-32 font-600 mb-4">
                            Applied Candidates –{' '}
                            <span className="font-400">
                                {jobData?.title} @{' '}
                                {jobData?.companyId
                                    ? getDomainValueForCode(
                                          jobData?.companyId,
                                          'COMPANY_CODE',
                                          state
                                      )
                                    : jobData?.otherCompany}
                            </span>
                        </h5>
                        <button
                            className="position-absolute top-20 right-20 text-secondary font-30 border-0 bg-transparent"
                            onClick={() =>
                                dispatch({
                                    type: 'TOGGLE_MODAL_VISIBILITY',
                                    payload: {
                                        modalName:
                                            'showJobViewApplieds',
                                    },
                                })
                            }
                        >
                        <i className="bi bi-x-circle-fill"></i>
                        </button>
                       <div className="row g-3 mb-3">
                            <div className="col-auto">
                                <select
                                    className="form-select"
                                    value={filterType}
                                    onChange={(e) =>
                                        setFilterType(e.target.value as 'ALL' | 'STUDENT' | 'ALUMNI')
                                    }
                                >
                                    <option value="ALL">Both ({interestedList.length})</option>
                                    <option value="STUDENT">Students ({studentCount})</option>
                                    <option value="ALUMNI">Alumni ({alumniCount})</option>
                                </select>
                            </div>

                            <div className="col-auto">
                            <select
                                className="form-select"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="ALL">All Status</option>
                                {applicationStatuses?.map((status: any) => (
                                    <option key={status.code} value={status.code}>
                                        {status.value}
                                    </option>
                                ))}
                            </select>
                        </div>
                        </div>
                        <div className="interestedCandidates y-scroll">
                             {Array.isArray(filteredList) &&
                                 filteredList.map((item) => (  
                                <div
                                    key={item?.uuid}
                                    className="interestedCandidate-block bg-gray-f5f5f5 p-4 rounded"
                                >
                                    <div className="row g-3">
                                        <div className="col-sm-auto">
                                            <img
                                                src={item.image}
                                                className="rounded-circle"
                                                width="60"
                                                alt=""
                                            />
                                        </div>

                                        <div className="col-sm">
                                            <h3 className="font-24 font-600 mb-0">
                                                {item.userName}{' '}
                                                <span
                                                    className={`badge rounded-pill font-14 ms-2  ${
                                                        item?.userTypeCode ===
                                                        'ALUMNI'
                                                            ? 'bg-danger'
                                                            : 'bg-warning'
                                                    }`}
                                                >
                                                    {item.userTypeCode
                                                    ?.toLowerCase()
                                                    .replace(/^\w/, (c:any) => c.toUpperCase())}
                                                </span>
                                                {item?.applicationStatus && (
                                                <span className="badge text-bg-secondary bg-opacity-25 text-dark font-12 font-400 rounded-pill ms-2">
                                                    {getDomainValueForCode(item?.applicationStatus, 'JOB_APPLICATION_STATUS', state)}
                                                 </span>
                                                )}
                                            </h3>
                                           
                                            <p className="mb-0">
                                               {item?.programName} {item.passOutYear} |{' '}
                                               {item.designation && item.designation  
                                                ?.toLowerCase()  
                                                .replace(/_/g, ' ')  
                                                .replace(/\b\w/g, (char:any) => char.toUpperCase()
                                                )} at  
                                                {' '}{item?.companyName}
                                            </p>

                                            <span className="font-14 fst-italic">
                                                Applied {' '}
                                                {getTimeAgo(item.createdAt)}
                                            </span>

                                            <hr className="opacity-25" />

                                            <p className="font-14 fst-italic mb-3">
                                             {item?.coverLetter && `“${item?.coverLetter}”`}
                                            </p>

                                            <div className="row g-2">
                                                <div className="col-auto">
                                                     <a
                                                        href={`/alumni/${item.uuid}/profile`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-border-gray height-40"
                                                    >
                                                        <span>View Profile</span>
                                                    </a>
                                                </div>

                                                <div className="col-auto">
                                                    <button
                                                        className="btn btn-green font-14 font-500 text-white height-35"
                                                        onClick={() => handleOpenModal(jobData,'VIEW_APPLICATION')}>
                                                        <span>View Application</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ViewAppliedsModal;
